import React, { useRef, useState } from "react"
import { LoginFormModel } from "../../../models/app/forms/auth/login-form"
import { Box, Button } from "@material-ui/core"
import { EnumDialogs, useDialogStore } from "services/store/dialog-store"
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { VariaveisAmbiente } from "ambiente"
import { EnumDeviceType } from "ambiente/ambiente-tipos"
import { DefaultFormRefs } from "components/forms/utils"
import { useThemeQueries } from "theme/util-styles"
import { Login } from "./components/login/login"
import { useHistory } from "react-router-dom";
import { useAuth } from "services/hooks/auth";
import { useEmpresaAtual } from "services/hooks/empresa";
import { usePessoaUsuario } from "services/hooks/pessoa-usuario";
import { useMesaStore } from "services/store/mesa-store";
import { useObterToken } from "services/store/obter-token";
import { convertToken } from "utils/convert-token";
import { MultiContratoModel } from "api/touchone/models/multi-contrato";
import { usePostConfirmarRedefinirSenha } from "api/touchone/requests/post-confirmar-redefinir-senha";
import { RedefinirSenhaProps, usePostRedefinirSenha } from "api/touchone/requests/post-redefinir-senha";
import { usePostValidarRedefinirSenha } from "api/touchone/requests/post-validar-redefinir-senha";
import { LoginClienteFormModel } from "models/app/forms/auth/login-cliente-form-model";
import { EnumTipoPerfil } from "models/enums/enum-tipo-perfil";
import { useNotificacoes } from "components/notificacoes";
import { OkIcon } from "utils/Icons/ok-icon"

export interface DialogAutenticarClienteProps {
    aberto: boolean,
}

export const DialogAutenticarCliente = ({
    aberto,
}: DialogAutenticarClienteProps) => {

    const desvincularMesa = useMesaStore(state => state.desvincularMesa);
    const { getEmpresaAtual } = useEmpresaAtual()
    const empresaId = getEmpresaAtual()?.id ?? ''

    const history = useHistory()
    const { auth, carregando: carregandoAuth } = useAuth()
    const { postRedefinirSenha, carregando: carregandoPostRedefinirSenha } = usePostRedefinirSenha()
    const { postValidarRedefinirSenha, carregando: carregandoPostValidarRedefinirSenha } = usePostValidarRedefinirSenha()
    const { postConfirmarRedefinirSenha, carregando: carregandoPostConfirmarRedefinirSenha } = usePostConfirmarRedefinirSenha()
    const { showErrorMessage, showSuccessMessage } = useNotificacoes()
    const { isTokenExpired, setToken } = useObterToken();
    const { carregarPessoa, carregando: carregandoCarregarPessoa } = usePessoaUsuario()
    const [senhaOuCodigo, setSenhaOuCodigo] = useState<{ senha: string, codigo: string }>({ senha: '', codigo: '' })
    const [emailOuTelefone, setEmailOuTelefone] = useState('')


    const carregando = carregandoCarregarPessoa || carregandoAuth || carregandoPostRedefinirSenha || carregandoPostValidarRedefinirSenha || carregandoPostConfirmarRedefinirSenha

    const openCloseDialog = useDialogStore(state => state.openCloseDialog);
    const isCordova = VariaveisAmbiente.deviceType === EnumDeviceType.CORDOVA
    const { isMobile } = useThemeQueries()

    const loginRefs = useRef<DefaultFormRefs<LoginFormModel>>(null);
    const [isInserirCodigo, setIsInserirCodigo] = useState<{ senha: boolean, codigo: boolean } | undefined>(undefined)
    const efetuarLogin = async (model: LoginFormModel, contratoId: string) => {
        try {
            let res = await auth({
                usuario: model.usuario,
                senha: model.senha,
                contratoId: contratoId
            })

            if (res.erro && res.statusCode !== 300) throw res.erro
            if (res.statusCode === 300) {
                const contratos = res.resultado?.data as MultiContratoModel[]
                if (empresaId) {
                    const temAMesmaEmpresa = contratos.filter(x => x.id === empresaId)
                    if (temAMesmaEmpresa.length === 0) throw new Error('Você não tem uma conta vinculada a esta empresa, faça um novo pedido')
                    res = await auth({
                        usuario: model.usuario,
                        senha: model.senha,
                        contratoId: temAMesmaEmpresa[0].contratoId ?? ''
                    })
                } else {
                    openCloseDialog<{ contratos: MultiContratoModel[], handleSelecionarContrato: (contratoId: string) => void }>
                        (EnumDialogs.SelecionarContrato, true, {
                            contratos: contratos,
                            handleSelecionarContrato: async (contratoId: string) => {
                                await efetuarLogin(model, contratoId)
                            }
                        })
                    return
                }
            }
            const resultado = res.resultado?.data

            const token = resultado?.accessToken
            if (!token) throw new Error('Nenhum token encontrado')
            if (isTokenExpired(token)) throw new Error('Token inválido')

            const getTokenInfo = convertToken(token)
            if (!getTokenInfo) throw new Error('Erro ao converter token')

            const temAMesmaEmpresa = getTokenInfo.empresa.filter(x => x.Id === empresaId)
            if (temAMesmaEmpresa.length === 0) {
                const isAdm = getTokenInfo.empresa[0].Perfil.Tipo === EnumTipoPerfil.Operador
                if (!isAdm) throw new Error('Você não tem uma conta vinculada a esta empresa, faça um novo pedido')

                if (getTokenInfo.empresa.length === 1) {
                    desvincularMesa();
                    await carregarPessoa(token)
                    setToken(token)
                    localStorage.setItem("empresaMobile", empresaId);
                    openCloseDialog(EnumDialogs.Autenticar, false)
                    history.push(`/${getTokenInfo.empresa[0]?.Id ?? ''}`)
                    return
                }
                openCloseDialog<{ handleSelecionarEmpresa: (empresaId: string) => Promise<void> }>(EnumDialogs.SelecionarEmpresa, true, {
                    handleSelecionarEmpresa: async (empresaId: string) => {
                        desvincularMesa();
                        await carregarPessoa(token)
                        setToken(token)
                        localStorage.setItem("empresaMobile", empresaId);
                        openCloseDialog(EnumDialogs.Autenticar, false)
                        history.push(`/${empresaId}`)
                    }
                })
                return
            }

            desvincularMesa();
            await carregarPessoa(token)
            setToken(token)
            localStorage.setItem("empresaMobile", temAMesmaEmpresa[0].Id);

            openCloseDialog(EnumDialogs.AutenticarCliente, false)
            openCloseDialog(EnumDialogs.SelecionarEmpresa, false)
            openCloseDialog(EnumDialogs.SelecionarContrato, false)
            showSuccessMessage('Login efetuado com sucesso')
            return


        } catch (error: any) {
            showErrorMessage(error.message)
        }
    }

    const autenticacaoCodigo = async () => {
        try {
            const modelRedefinicao: RedefinirSenhaProps = new RedefinirSenhaProps()
            if (/^\d+$/.test(emailOuTelefone)) {
                modelRedefinicao.telefone = emailOuTelefone
            } else {
                modelRedefinicao.email = emailOuTelefone
            }

            const resValidar = await postValidarRedefinirSenha({
                telefone: modelRedefinicao.telefone,
                email: modelRedefinicao.email,
                cpfCnpj: modelRedefinicao.cpfCnpj,
                redefinirCodigo: senhaOuCodigo.codigo
            })
            if (resValidar.erro) throw resValidar.erro

            const novaSenhaUsuario = (modelRedefinicao.telefone || modelRedefinicao.email) + '@menuvip'
            const resConfirm = await postConfirmarRedefinirSenha({
                telefone: modelRedefinicao.telefone,
                email: modelRedefinicao.email,
                cpfCnpj: modelRedefinicao.cpfCnpj,
                redefinirCodigo: senhaOuCodigo.codigo,
                senha: novaSenhaUsuario,
                senhaConfirmacao: novaSenhaUsuario,
            })
            if (resConfirm.erro) throw resConfirm.erro

            efetuarLogin({
                usuario: emailOuTelefone,
                senha: novaSenhaUsuario,
            }, '')
        } catch (err: any) {
            showErrorMessage(err.message)
        }
    }

    const enviarCodigo = async (model: LoginClienteFormModel) => {
        try {
            const modelRedefinicao: RedefinirSenhaProps = new RedefinirSenhaProps()
            if (/^\d+$/.test(model.usuario)) {
                modelRedefinicao.telefone = model.usuario
            } else {
                modelRedefinicao.email = model.usuario
            }
            const res = await postRedefinirSenha(modelRedefinicao)
            if (res.erro) throw res.erro
            setEmailOuTelefone(model.usuario)
            setIsInserirCodigo({ codigo: true, senha: false })
        } catch (err: any) {
            showErrorMessage(err.message)
        }
    }

    const reenviarNovamente = () => {
        enviarCodigo({
            usuario: emailOuTelefone,
        })
    }

    return (
        <DialogSaurus
            aberto={aberto}
            titulo={isInserirCodigo ? "Inserir Código" : isCordova ? 'Autenticação de Administrador' : 'Entrar na Conta'}
            isButtonTitleClose
            tamanho="sm"
            fullScreen={isMobile}
            handleClickClose={() => openCloseDialog(EnumDialogs.AutenticarCliente, false)}
            removerPaddingContent
            bottomArea={(
                <Box p={2} gridGap={8} display="flex" flexDirection="column">
                    {isInserirCodigo ? (
                        <>
                            <Button fullWidth onClick={() => autenticacaoCodigo()} color="primary" size="large" variant="contained">
                                <OkIcon tipo="BUTTON_PRIMARY" />
                                Confirmar
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button fullWidth onClick={() => loginRefs.current?.submitForm()} color="primary" size="large" variant="contained">
                                <OkIcon tipo="BUTTON_PRIMARY" />
                                {!isInserirCodigo ? "Confirmar" : "Entrar"}
                            </Button>
                        </>
                    )}
                </Box>
            )}
        >
            <Login
                loginRefs={loginRefs}
                isCordova={isCordova}
                isInserirCodigo={isInserirCodigo}
                autenticacaoCodigo={autenticacaoCodigo}
                setSenhaOuCodigo={setSenhaOuCodigo}
                senhaOuCodigo={senhaOuCodigo}
                carregando={carregando}
                enviarCodigo={enviarCodigo}
                reenviarNovamente={reenviarNovamente}
            />
        </DialogSaurus >
    )
}
